import React, { useContext, useEffect } from 'react';
import propTypes from 'prop-types';
import { QuoteContext } from '../QuoteProvider';
import { Tooltip } from '../../Tooltip';
import { formatCurrency } from '../../../utilities/financing';

const InstallationOption = ({
  quantity, pricing, info, data,
}) => {
  const { installOption, setInstallOption } = useContext(QuoteContext);

  const buildCommerceToolsObject = () => {
    const commerceToolsObject = {
      id: data.id,
      type: data.productType,
      name: data.sku,
      description: info.description,
      checked: true,
      disabled: true,
      unitPrice: pricing[data.sku],
      qty: quantity,
      free: false,
      position: 0,
      subs: [],
    };

    if (info.includes) commerceToolsObject.subs.push(info.includes);
    if (info.extras) commerceToolsObject.subs.push(info.extras);

    return commerceToolsObject;
  };

  const updateSelection = () => {
    const installProduct = buildCommerceToolsObject();

    setInstallOption(installProduct);
  };

  const renderPrice = () => {
    const className = installOption.id === data.id ? 'cmp-quote-option__total--selected' : '';

    return (
      <span className={className} data-testid="total-price">
        {formatCurrency(pricing[data.sku] * quantity)}
      </span>
    );
  };

  useEffect(() => {
    if (installOption.id === data.id) {
      updateSelection();
    }
  // we only want this to run once, regardless of dependency changes
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="cmp-quote-option cmp-quote-option--installation">
      <div className="cmp-quote-option__item">
        <input className="cmp-quote-option__input" id={`installationType-${data.sku}`} type="radio" name="installationType" checked={installOption.id === data.id} onChange={updateSelection} />
        <label className="cmp-quote-option__selection-label" htmlFor={`installationType-${data.sku}`}>
          {info.name}
          {' '}
          Installation
        </label>
      </div>
      <span className="cmp-quote-option__quantity">
        Quantity:
        {' '}
        {quantity}
      </span>
      <span className="cmp-quote-option__unit-price">
        Unit Price: $
        {pricing[data.sku]}
      </span>
      <span className="cmp-quote-option__total">
        {renderPrice(data.sku)}
      </span>
      <div className="cmp-quote-option__description">
        {/* eslint-disable react/no-danger */}
        <div className="cmp-quote-option__details">
          <div className="util-display-inline" dangerouslySetInnerHTML={{ __html: info.description }} />
          {' '}
          <Tooltip name={`${info.name} installation value`} />
        </div>

        {info.includes && <h4 className="cmp-quote-option__heading">Includes</h4>}
        <div className="cmp-quote-option__details">
          <div className="util-display-inline" dangerouslySetInnerHTML={{ __html: info.includes }} />
          {' '}
          {/* only Free Tire Repair needs a tooltip in the TD Standard installation section */}
          {info.name === 'TD Standard'
            ? <Tooltip name="free tire repair" />
            : <Tooltip name={`${info.name} installation includes`} />}
        </div>

        {info.extras && <h4 className="cmp-quote-option__heading">Extras</h4>}
        <div className="cmp-quote-option__details">
          <div className="util-display-inline" dangerouslySetInnerHTML={{ __html: info.extras }} />
          {' '}
          <Tooltip name={`${info.name} installation extras`} />
        </div>
        {/* eslint-enable react/no-danger */}
      </div>
    </div>
  );
};

InstallationOption.propTypes = {
  quantity: propTypes.number,
  pricing: propTypes.shape({
    standardInstallation: propTypes.number,
    economyInstallation: propTypes.number,
    trailerTireInstallation: propTypes.number,
  }),
  info: propTypes.shape({
    name: propTypes.oneOf(['TD Standard', 'Economy', 'Trailer Tire']),
    description: propTypes.string,
    includes: propTypes.string,
    extras: propTypes.string,
  }),
  data: propTypes.shape({
    id: propTypes.number,
    productType: propTypes.string,
    sku: propTypes.oneOf(['TDSTANDARD', 'ECONOMY', 'TRAILER']),
  }),
};

export { InstallationOption };
